import { useNuxtApp } from '#imports';
import type { CoreServices } from '~/service/core';

export default function useEVMCore(): CoreServices {
    const { $evmCore } = useNuxtApp();

    if (!$evmCore) {
        throw new Error('evmCore not provided from root app!');
    }
    return <CoreServices>$evmCore;
}
